module.exports = " <div v-on:click=OpenInputFile> <slot></slot> </div> <input style=\"display: none\" id=\"{{ id || name }}\" type=file name=\"{{ name }}\" v-bind-boolean:multiple=multiple @change=fileInputChange accept=.*> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/game/uploadFiles.vue
// module id = 491
// module chunks = 10